import React from "react";

export default function FAQ() {
  return (
    <div className="privacy-maincard">
      <div style={{ padding: "20px" }}>
        <div className="privacy-maintitle">
          <h1>Frequently Asked Questions (FAQ)</h1>
          <p>
            Welcome to the FAQ page of LEGITIMATELY. Find answers to common
            questions about our platform.
          </p>
          <div className="privacy_cards">
            <div className="privacy_title">
              <h2>Q: What is LEGITIMATELY?</h2>
              <p>
                A: LEGITIMATELY is your trusted platform fo r premium services
                and solutions tailored to your needs.
              </p>
            </div>
            <div className="privacy_title">
              <h2>Q: How can I get started?</h2>
              <p>
                A: Sign up for an account, explore our features, and start
                enjoying the benefits of LEGITIMATELY today.
              </p>
            </div>
            <div className="privacy_title">
              <h2>Q: How do I contact support?</h2>
              <p>
                A: Our support team is available 24/7 through the Help Centre or
                via the Contact Us page.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
